import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = `ai/assistant/<assistant-name>/conversationStarters`;

export function useAIAssistantConversationStarterQuery(params: { assistantName: string }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, params.assistantName],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.AIConversationStarter[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `ai/assistant/${params.assistantName}/conversationStarters`,
				}),
				'GET'
			),
	});
}
